import React from 'react';
import { useT } from '../../i18n/LanguageContext';

export function pendingIvrCount(counts = {}) {
  return (counts.needs_review || 0) + (counts.submitted || 0);
}

export default function PendingActionsCard({ orderCounts, ivrCounts, navigate }) {
  const t = useT();
  const actions = [
    {
      title: t('{n} Orders Pending', { n: orderCounts.pending || orderCounts.submitted || 0 }),
      subtitle: t('Awaiting processing'),
      icon: 'shopping_cart',
      bgColor: 'bg-[#fff8db]',
      btnColor: 'bg-[#eaa13b]',
      btnText: t('Review'),
      onClick: () => navigate('/orders'),
    },
    {
      title: t('{n} IVR Pending', { n: pendingIvrCount(ivrCounts) }),
      subtitle: t('Awaiting verification'),
      icon: 'verified_user',
      bgColor: 'bg-[rgba(226,231,251,0.6)]',
      btnColor: 'bg-[#363998]',
      btnText: t('Verify'),
      onClick: () => navigate('/ivr-details'),
    },
    {
      title: t('{n} Orders Shipped', { n: orderCounts.shipped || 0 }),
      subtitle: t('In transit'),
      icon: 'local_shipping',
      bgColor: 'bg-[rgba(222,252,237,0.6)]',
      btnColor: 'bg-[#007a55]',
      btnText: t('Track'),
      onClick: () => navigate('/shipments'),
    },
  ];

  return (
    <div className="bg-white border border-[#e2e8f0] rounded-[14px] shadow-sm flex-1">
      <div className="px-5 py-4 bg-[rgba(226,232,240,0.2)] border-b border-[#e2e8f0] rounded-t-[14px]">
        <h3 className="text-base font-semibold text-[#0f172a]">{t('Pending Actions')}</h3>
      </div>
      <div className="p-5 space-y-3">
        {actions.map((action, i) => (
          <div
            key={i}
            className={`${action.bgColor} opacity-70 rounded-[10px] px-4 py-3 flex items-center gap-3`}
          >
            <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center shrink-0">
              <span className="material-symbols-outlined text-[#64748b] text-[18px]">
                {action.icon}
              </span>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-[13px] font-semibold text-[#0f172a]">{action.title}</p>
              <p className="text-[11px] text-[#64748b]">{action.subtitle}</p>
            </div>
            <button
              onClick={action.onClick}
              className={`${action.btnColor} text-white text-xs font-medium px-3 py-1 rounded-md shrink-0`}
            >
              {action.btnText}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
